
<div>
    <div id="fast-analysis-poster">
        <div class="row no-gutters">
            <div class="col col-2">
                <b-icon-star-fill></b-icon-star-fill>
            </div>
            <div class="col h4">
                <b>{{ $t("overview.poster.title") }}</b>
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col col-2">
                <b-icon-check />
            </div>
            <div class="col">
                {{ $t("overview.poster.description.0", [formatInteger(flagsTotal)]) }}
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col col-2">
                <b-icon-check />
            </div>
            <div class="col">
                {{ $t("overview.poster.description.1") }}
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col col-2">
                <b-icon-check />
            </div>
            <div class="col">
                {{ $t("overview.poster.description.2") }}
            </div>
        </div>

        <div class="row no-gutters">
            <div class="col col-2">
                <b-icon-check />
            </div>
            <div class="col">
                {{ $t("overview.poster.description.3") }}
            </div>
        </div>

        <button class="btn" @click="order(name, ico, 'lite')">{{ $t("button.order") }}</button>
    </div>

    <div id="adam-zabransky">
        <blockquote class="blockquote">
            <p class="mb-0 text-center">
                “Kontrola ukázala na řadu problémů a rizik u evidence smluv a zakázek.
                    Pomohla nám nastartovat systémové změny k lepšímu.”
            </p>
            <footer class="blockquote-footer text-center">
                <br />
                Adam Zábranský
                <br />
                <cite>radní Hlavního města Prahy</cite>
            </footer>
        </blockquote>
    </div>
</div>
